import { useMemo } from "react";
import { partners, } from "../../Types";
import useAdvisorInfo from "./useAdvisorInfo";
const isPartner = (partner) => {
    return partners.some((p) => p === partner);
};
export default function useAdvisorPartner(advisorId, auth) {
    const advisorInfo = useAdvisorInfo(advisorId, auth);
    const result = useMemo(() => {
        if (advisorInfo.isLoading || advisorInfo.hasError) {
            return advisorInfo;
        }
        const adminAndAdvisorRoles = advisorInfo.data.advisorRoles.filter((role) => role.displayName.endsWith(" Advisor") ||
            role.displayName.endsWith(" Admin"));
        if (adminAndAdvisorRoles.length > 0) {
            const role = adminAndAdvisorRoles[0]?.displayName;
            if (role !== undefined) {
                const partner = role.replace(" Advisor", "").replace(" Admin", "");
                if (isPartner(partner)) {
                    return { data: partner, isLoading: false, hasError: false };
                }
                return {
                    data: undefined,
                    isLoading: false,
                    hasError: true,
                    error: "Valid partner not found!",
                };
            }
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: "Valid partner not found!",
            };
        }
        return { data: "Farther", isLoading: false, hasError: false };
    }, [advisorInfo]);
    return result;
}
//# sourceMappingURL=useAdvisorPartner.js.map